var PhxCheckout = (function (PhxCheckout) {
    PhxCheckout.creditCardValidationHelper = function () {

      var _hidePayPal = function() {
        document.getElementById('usePP').style.display = "none";
      };

      var _getValidYears = function () {
          var yearEl = document.getElementById('id_expirationYear');
          var year = new Date().getFullYear();
          for (var i = 0; i < 10; i++) {
              var option = document.createElement("option");
              option.text = (i+year).toString();
              yearEl.add(option);
          }
      };

      var _getValidMonths = function () {
          var monthEl = document.getElementById('id_expirationMonth');
          for (var i = 1; i <= 12; i++) {
              i = i.toString();
              var option = document.createElement("option");
              if(i.length === 1){
                i = "0" + i;
              }
              option.text = i;
              monthEl.add(option);
          }
      };

      var validateCreditCardNumber = true;

      var _hideErrorById = function(arrOfIds) {
        arrOfIds.forEach(function(element) {
          document.getElementById(element).style.display = 'none';
        })
      };

      var _validateCreditCard = function (){
          var numberValid = _validateCreditCardNumber();
          var securityCodeValid = _validateSecurityCode();
          var dateValid = _validateExpirationDate();
          var postalValid = _validatePostalWithMessage();
          var isFormValid = numberValid === "OK" && securityCodeValid === "OK" && dateValid === "OK" && postalValid === "OK";

          if(!isFormValid && document.getElementById("group_error")) {
            document.getElementById("group_error").style.display = 'inline';
          }

          return isFormValid;
      }

      /**
       Validate the provided Credit Card number.
       - Expects a 16 digit number
       - Uses the Luhn algorithm checksum for validation
       http://en.wikipedia.org/wiki/Luhn_algorithm

       Output: Validation status
       **/
      var _validateCreditCardNumber = function () {
          if (_getValidateCreditCardNumber() == false) {
              return;
          }
          var errorMessageId;
          var ccElement = document.getElementById('id_number');
          var number = ccElement.value;
          var ccNumberErrorId = document.getElementById('cc_number_error');
          var ccElementsToHideById = ['number_bad_length', 'number_bad_chars', 'number_unaccepted_type', 'number_checksum_fail', 'number_empty', 'cc_errors_wrapper'];
          var cardType = PhxCheckout.checkoutHelper.getCardType();
          _hideErrorById(ccElementsToHideById);

          if (number) {
              //remove spaces
              number = number.replace(/\s/g, "");
              //remove dashes
              number = number.replace(/-/g, "");

              var length = number.length;

              //Length varies per CC type. Doesn't exceed 16. The lower limit is just a
              //good to have check
              if (length < 12 || length > 19) {
                errorMessageId = 'number_bad_length';
              } else if (cardType === 'VI' && (length !== 16 && length !== 19)) {
                errorMessageId = 'number_bad_length';
              } else if (cardType === 'AX' && (length != 15)) {
                errorMessageId = 'number_bad_length';
              } else if (  ( cardType === 'MC' || cardType === 'DI') && (length !== 16)) {
                errorMessageId = 'number_bad_length';
              }
              //check invalid characters
              else if (/\D/.test(number)) {
                errorMessageId = 'number_bad_chars';
              }
              else if(!_cardIsAcceptedType(number)) {
                errorMessageId = 'number_unaccepted_type';
              }
              else {
                  //convert to an array of ints
                  var numbers = number.trim().split('');
                  for (i = 0; i < numbers.length; i++) {
                      numbers[i] = parseInt(numbers[i]);
                  }

                  //Skipping check digit, double every other digit.
                  for (i = numbers.length - 2; i >= 0; i -= 2) {
                      //double the value
                      var twice = numbers[i] * 2;

                      //if doubling produces a two digit number. sum up the digits.
                      if (twice > 9) {
                          var twice_str = String(twice);
                          twice = 1 + parseInt(twice_str[1]);
                      }

                      numbers[i] = twice;
                  }

                  //add the single digits, including the check digit, to the sum
                  var sum = 0
                  for (var i = 0; i < numbers.length; i++) {
                      sum += numbers[i];
                  }

                  if (sum % 10 == 0) {
                    ccNumberErrorId.style.display = 'none';
                    ccElement.className = '';
                    if(document.getElementById('ccValidationSuccess')) {
                      document.getElementById('ccValidationSuccess').className = 'success';
                    }
                    return 'OK';
                  }
                  else {
                      // return 'NUMBER_CHECKSUM_FAIL';
                      errorMessageId = 'number_checksum_fail';
                  }
              }
          } else {
              // return 'NUMBER_EMPTY';
              errorMessageId = 'number_empty';
          }

          if(errorMessageId) {
            ccNumberErrorId.style.display = 'inline';
            document.getElementById('cc_errors_wrapper').style.display = 'inline-block';
            document.getElementById(errorMessageId).style.display = 'inline';
            ccElement.className = 'error';
            if(document.getElementById('ccValidationSuccess')) {
              document.getElementById('ccValidationSuccess').className = '';
            }
            PhxCheckout.checkoutHelper.updateFrameSize();
          }
      };

      /**
       Validate Expiration Date
       - only validates once both month and year values are available

       Output: Modifies the forms expirationDate field. Adds a status field to the input.
       **/
      var _validateExpirationDate = function () {
          var dateErrorMessageId;
          var monthElement = document.getElementById('id_expirationMonth');
          var yearElement = document.getElementById('id_expirationYear');
          var month = monthElement.value;
          var year = yearElement.value;
          var expiratonErrorId = document.getElementById('expiration_error');
          var dateElementsToHideById = ['invalid_month', 'expiration_date_in_past', 'expiration_date_invalid', 'expiration_date_required'];
          _hideErrorById(dateElementsToHideById);

          //ExpressCart since user is allowed to input their own numbers
          if (month && month.length === 1) {
            month = "0" + month;
          }
          if (year && year.length <= 2) {
            year = "20" + year;
          }

          var currentYear = new Date().getFullYear();

          if(month && year) {
              //Spaces throw the Date parsing off. Strip them.
              month = month.replace(/\s/g, "");
              year = year.replace(/\s/g, "");

              /**
               Javascript Date uses a zero indexed month value. Since the parsed date is 00:00 hour
               on the first of the month. Subtract a day to obtain UI month entered.
               **/
              var expirationDate = new Date(year, month) - 1;
              if (expirationDate && !isNaN(expirationDate)) {
                  var now = new Date();
                  var date = new Date(expirationDate);
                  if (month > 12 || month < 1) {
                    // return "INVALID_MONTH";
                    dateErrorMessageId = 'invalid_month';
                  }
                  else if (date < now) {
                      // return "EXPIRATION_DATE_IN_PAST";
                      dateErrorMessageId = 'expiration_date_in_past';
                  } else if (year > (currentYear + 10) ) {
                      dateErrorMessageId = 'expiration_date_invalid'
                  } else {
                      // return "OK";
                      expiratonErrorId.style.display = 'none';
                      monthElement.className = '';
                      yearElement.className = '';
                      if(document.getElementById('labelExpMonth')) {
                        document.getElementById('labelExpMonth').className = 'success';
                      }
                      return 'OK';
                  }
              } else {
                  // return "EXPIRATION_DATE_INVALID";
                  dateErrorMessageId = 'expiration_date_invalid';
              }
          } else {
              // return "REQUIRED";
              dateErrorMessageId = 'expiration_date_required';
          }

          if(dateErrorMessageId) {
            expiratonErrorId.style.display = 'inline-block';
            document.getElementById(dateErrorMessageId).style.display = 'inline';
            monthElement.className = 'error';
            yearElement.className = 'error';
            if(document.getElementById('labelExpMonth')) {
              document.getElementById('labelExpMonth').className = '';
            }
          }
      };

      /**
       Validate Security Code
       - Checks if code contains a non numeric character
       - Checks for between 3 and 4 digits

       Output: Modifies the form securityCode input. Adds the following fields: status
       **/
      var _validateSecurityCode = function () {
          var cvvErrorMessageId;
          var cvcElement = document.getElementById('id_securityCode');
          var securityCode = cvcElement.value;
          var cvcErrorId = document.getElementById('cvc_error');
          var cvvElementsToHideById = ['security_code_bad_chars', 'security_code_invalid', 'security_code_required'];
          _hideErrorById(cvvElementsToHideById);

          if(securityCode){
              //Remove all spaces
              securityCode = securityCode.replace(/\s/g, "");

              if (/\D/.test(securityCode)) {
                  cvvErrorMessageId = 'security_code_bad_chars';
              } else if (/^\d{3,4}$/.test(securityCode)) {
                  var cvvLength = _getCVVLengthForCreditCard()
                  var isValidCVV = cvvLength === securityCode.length;

                  if (! isValidCVV) {
                      cvvErrorMessageId = 'security_code_invalid';
                  } else {
                      cvcErrorId.style.display = 'none';
                      cvcElement.className = '';
                      if(document.getElementById('securityCodeValidationSuccess')) {
                        document.getElementById('securityCodeValidationSuccess').className = 'success';
                      }

                      return 'OK';
                  }
              } else {
                  cvvErrorMessageId = 'security_code_invalid';
              }
          } else {
              cvvErrorMessageId = 'security_code_required';
          }

          if(cvvErrorMessageId) {
            cvcErrorId.style.display = 'inline-block';
            document.getElementById(cvvErrorMessageId).style.display = 'inline';
            cvcElement.className = 'error';
            if(document.getElementById('securityCodeValidationSuccess')) {
              document.getElementById('securityCodeValidationSuccess').className = '';
            }
            PhxCheckout.checkoutHelper.updateFrameSize();
          }
      };

      /***
       * Determines if the credit card number is one of the accepted types
       * @param creditCard: credit card number
       * @param acceptedCreditCards: card types to check against
       */
      var _cardIsAcceptedType = function(creditCard) {
          var acceptedCreditCards = PhxCheckout.acceptedCreditCards;
          var IssuerIdentifierRegex = {
              "Visa" : /^4/,
              "MasterCard" : /^(5[0-5]|2[2-7][0-9])/,
              "American Express" : /^3[47]/,
              "Discover": /^6([045]|22|011)/
          };
          for(var i = 0; acceptedCreditCards && i < acceptedCreditCards.length; i++) {
              if (IssuerIdentifierRegex[acceptedCreditCards[i]] && IssuerIdentifierRegex[acceptedCreditCards[i]].test(creditCard)) {
                  return true;
              }
          }
          return false;
      };

      var _setAcceptedCardTypes = function(cardTypes) {
        PhxCheckout.acceptedCreditCards = cardTypes;
      }

      var _getValidateCreditCardNumber = function() {
          return validateCreditCardNumber;
      };

      var _setValidateCreditCardNumber = function(validate) {
          validateCreditCardNumber = validate;
          PhxCheckout.checkoutHelper.setPaymentType('CreditCard');
      };

      var _obfuscateCreditCard = function() {
        var ccElement = document.getElementById('id_number');
        var ccValue = ccElement.value;
        if(ccValue.length > 0){
          var obfuscatedElement = document.getElementById('obfuscated_number');
          obfuscatedElement.style.display = "inline-block";
          ccElement.style.display = "none";
          obfuscatedElement.value = "****" + ccValue.substring(ccValue.length-4);
        }
      };

      var _restoreCreditCardValue = function() {
        var ccElement = document.getElementById('id_number');
        ccElement.style.display = "inline-block";
      };

      var _hideObfuscated = function() {
        //on edit and onfocus, hide the obfuscated element
        var obfuscatedElement = document.getElementById('obfuscated_number');
        obfuscatedElement.style.display = "none";

        //clear credit card info and display the input field
        var ccElement = document.getElementById('id_number');
        ccElement.value = "";
        ccElement.style.display = "inline-block";
      };

      var _validatePostalCode = function(obj) {
        //reset old errors
        var cvvElementsToHideById = ['postal_code_required', 'postal_code_invalid'];
        _hideErrorById(cvvElementsToHideById);

        var postalCode = obj.value;
        var postalMessageId = _getPostalCodeErrorId(postalCode);

        _setPostalError(postalMessageId);

        return postalMessageId
      }

      var _setPostalError = function(postalMessageId) {
        var postalErrorId = document.getElementById('postal_error');
        var postalElement = document.getElementById('id_postalCode');
        if(postalMessageId) {
          postalErrorId.style.display = 'inline-block';
          document.getElementById(postalMessageId).style.display = 'inline';
          postalElement.className = 'error';
        } else {
          postalErrorId.style.display = 'none';
          postalElement.className = '';
        }
        PhxCheckout.checkoutHelper.updateFrameSize();
      }

      var _validatePostalWithMessage = function() {
        var postalElementDiv = document.getElementById('postalCode');
        if (!postalElementDiv || postalElementDiv.style.display === 'none') return 'OK';
        var postalElement = document.getElementById('id_postalCode');
        var postalMessageId = _validatePostalCode(postalElement);
        //return OK if we don't return an error element
        return postalMessageId ? postalMessageId : 'OK';
      }

      var _getPostalCodeErrorId = function(postalCode) {
        if (!postalCode || !postalCode.trim()) {
          return 'postal_code_required';
        }
        //TODO: Support postal codes for non-US geos
        var postalCodeRegex = postalCodeRegex = /^(?!12345)\d{5}(?:[-\s]\d{4})?$/;
        return postalCodeRegex.test(postalCode) ? '' : 'postal_code_invalid'
      }


      //Return CVV length for Credit Card type (Visa, Discover and MasterCard are 3 digits. Amex or default is 4).
      function _getCVVLengthForCreditCard() {
          var cardType = PhxCheckout.checkoutHelper.getCardType();
          return cvvLength = (cardType === 'VI' || cardType === 'MC' || cardType === 'DI') ? 3 : 4;
      }


        return {
          validateCreditCardNumber: _validateCreditCardNumber,
          validateExpirationDate: _validateExpirationDate,
          validateSecurityCode: _validateSecurityCode,
          validateCreditCard: _validateCreditCard,
          ifValidateCreditCardNumber: _getValidateCreditCardNumber,
          setValidateCreditCardNumber: _setValidateCreditCardNumber,
          getCVVLengthForCreditCard: _getCVVLengthForCreditCard,
          getValidMonths: _getValidMonths,
          getValidYears: _getValidYears,
          hidePayPal: _hidePayPal,
          setAcceptedCardTypes: _setAcceptedCardTypes,
          obfuscateCreditCard: _obfuscateCreditCard,
          restoreCreditCardValue: _restoreCreditCardValue,
          hideObfuscated: _hideObfuscated,
          validatePostalCode: _validatePostalCode,
          validatePostalWithMessage: _validatePostalWithMessage,
          setPostalError:_setPostalError,
          //only for testing
          _cardIsAcceptedType: _cardIsAcceptedType
        };
    }();

    return PhxCheckout;

}(PhxCheckout || {}));
